import React from "react";
                  
export function MyPage() {
    return <h1>Hello!</h1>
}